const state = {
  checkout: {},
  sidecartOpen: false
}

const mutations = {
  SET_CHECKOUT (state, checkout) {
    state.checkout = checkout
  },
  OPEN_SIDECART (state) {
    state.sidecartOpen = true
  },
  CLOSE_SIDECART (state) {
    state.sidecartOpen = false
  }
}

const actions = {
  init ({ commit }) {
    actions.fetchCart(commit);
  },
  fetchCart (commit) {
    // forcing clean cart request for IE11
    let timestamp = new Date().getTime()

    fetch(`/cart.js?q=${timestamp}`)
      .then((blob) => blob.json())
      .then(data => {
        commit('SET_CHECKOUT', data)
      })
  },
  addItem ({ rootState, state, commit, dispatch }, { id, quantity, properties = {}, selling_plan }) {
    // forcing clean cart request for IE11
    let timestamp = new Date().getTime()

    // Build cart item data
    const cartItem = { id, quantity, properties };
    
    // Add selling plan if provided
    if (selling_plan) {
      cartItem.selling_plan = selling_plan;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartItem),
    })
      .then(() => {
        // if this is a subscription product we need to refresh the cart products
        // this is because subscription products cannot be pulled from the product endpoint
        const productExistsInState = rootState.products.all.find((product) => {
          return product.variants.find((variant) => variant.id === id);
        });

        if (!productExistsInState && properties && properties.subscription_id) {
          dispatch('products/init', null, { root: true })
        }
      })
      .then(() => {
        actions.fetchCart(commit)
      })
      .catch(err => {
        console.log(err)
        reject(new Error('Unable to add the item to your cart.'))
      })
  },
  updateItem ({ commit }, { line, quantity }) {
    return new Promise((resolve, reject) => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ line, quantity }),
      })
        .then((blob) => blob.json())
        .then((data) => {
          let item = data.items[line - 1]

          if (item && item.quantity < parseInt(quantity, 10)) {
            this.dispatch('toast/send', {
              text: `Could not add more ${item.title}s. They're all in your cart!`,
              type: 'error'
            }, { root: true })
          }

          commit('SET_CHECKOUT', data)
          resolve()
        })
        .catch(err => {
          console.log(err)
          reject(new Error('Unable to update the item in your cart.'))
        })
    })
  },
  removeItem ({ commit }, line) {
    return new Promise((resolve, reject) => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ line, quantity: 0 }),
      })
        .then((blob) => blob.json())
        .then(data => {
          commit('SET_CHECKOUT', data)
          resolve();
        })
        .catch(err => {
          console.log(err)
          reject(new Error('Unable to remove the item from your cart.'))
        })
    })
  },
  openSidecart: ({ commit }) => commit('OPEN_SIDECART'),
  closeSidecart: ({ commit }) => commit('CLOSE_SIDECART')
}

export default { namespaced: true, state, mutations, actions }
